<template>
  <div class="form-wrapper w-full">
    <div class="pb-6">
      <slot name="header"></slot>
    </div>
    <slot name="default"></slot>
    <slot name="footer"></slot>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
